module.exports = __webpack_public_path__ + "img/leihs2.e912ad49.png";